import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Button,
  Container,
  Flex,
  Input,
  Select,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { fetcher } from "../../config/axiosConfig.ts";
import { swrOptions } from "../../const.ts";
import { useDetails } from "../../hooks/useDetails.ts";
import CardItem from "../card/cartdItem.tsx";
import { useCategory } from "../../hooks/useCategory.ts";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

export default function SearchEvent() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const selectValue = searchParams.get("category");

  const [searchField, setSearchField] = useState<string>("");
  const [searchData, setSearchData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState(0);

  const [categoryFilter, setCategoryFilter] = useState<any>(selectValue);
  const [attendanceFilter, setAttendanceFilter] = useState<string>("");
  const [eventName, setEventName] = useState<string>("");
  const [dateFilter, setDateFilter] = useState<string>("");
  const [ticketType, setTicketType] = useState<string>("");

  const [token, setToken] = useState(false);

  useEffect(() => {
    const accessToken = Cookies.get("access");
    if (accessToken) {
      setToken(true);
    }
  }, []);

  const accessToken = Cookies.get("access");

  // Fetch categories
  const { data: categoryData } = useCategory();

  // Fetch events with pagination
  const { data: filteredData, isLoading: loadingFilter } = useSWR(
      `/events-ms/api/v1/events/filter?pageNumber=${pageNumber}&pageSize=10` +
      `${categoryFilter ? `&category=${categoryFilter.trim()}` : ""}` +
      `${attendanceFilter ? `&attendanceTypeEnum=${attendanceFilter.trim()}` : ""}` +
      `${eventName ? `&eventName=${eventName}` : ""}` +
      `${dateFilter ? `&date=${dateFilter.trim()}` : ""}` +
      `${ticketType ? `&ticketType=${ticketType.trim()}` : ""}`,
      fetcher,
      swrOptions
  );

  const { data, isLoading } = useDetails();

  useEffect(() => {
    if (accessToken) {
      if (filteredData?.body?.eventsList) {
        setSearchData((prev) => [...prev, ...filteredData.body.eventsList]);
      }
    } else {
      if (!isLoading && data) {
        setSearchData(data.body);
      }
    }
  }, [data, isLoading, filteredData, accessToken]);

  // Input value changing for search part

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchField(e.target.value);
  };


  // Filter change handler
  const handleFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target;
    setSearchData([]); // Clear previous results
    setPageNumber(0); // Reset pagination

    switch (name) {
      case "Category":
        setCategoryFilter(value); // Now using categoryKey instead of name
        break;
      case "EventName":
        setEventName(value); // Now using categoryKey instead of name
        break;
      case "ATTENDANCE":
        setAttendanceFilter(value);
        break;
      case "date":
        setDateFilter(value);
        break;
      case "ticketType":
        setTicketType(value);
        break;
      default:
        break;
    }
  };


  // Clear filters
  const handleClearFilter = () => {
    setCategoryFilter("");
    setAttendanceFilter("");
    setDateFilter("");
    setTicketType("");
    setSearchField("");
    setSearchData([]);
    setPageNumber(0);
  };

  // Load more function
  const handleLoadMore = () => {
    setPageNumber((prevPage) => prevPage + 1);
  };

  return (
      <Box p={{ base: "165px 0px", md: "200px 0 " }}>
        <Container maxW="95vw">
          {!token ? (
              <Alert status="warning" variant="subtle" flexDirection="column" alignItems="center"
                     justifyContent="center" textAlign="center" py={6} borderRadius="md" mb={6}>
                <AlertIcon boxSize="40px" mr={0} />
                <AlertTitle mt={4} mb={1} fontSize="lg">
                  Attention Required!
                </AlertTitle>
                <AlertDescription maxWidth="sm">
                  To access more events, please log in to your account.
                </AlertDescription>
              </Alert>
          ) : (
              <>
                <Input
                    py={"20px"}
                    size={"lg"}
                    name="EventName"
                    placeholder={t("Search Here")}
                    onChange={handleFilterChange}
                />
                <Flex justify={"flex-start"} gap={"20px"} my={"40px"}
                      flexDirection={{ base: "column", sm: "row", md: "row" }}>
                  <Box display={"flex"} gap={"20px"} flexDirection={{ base: "column", md: "row" }}>
                    <Select
                        placeholder={t("Category")}
                        size={{ base: "lg", md: "md" }}
                        bg={"#F2F4F7"}
                        name="Category"
                        onChange={handleFilterChange}
                        value={categoryFilter ?? ""}
                    >
                      {categoryData?.body.map(({ name, categoryKey }) => (
                          <option key={categoryKey} value={categoryKey}>
                            {name}
                          </option>
                      ))}
                    </Select>
                    <Select placeholder={t("Attendance")} size={{ base: "lg", md: "md" }} bg={"#F2F4F7"}
                            name="ATTENDANCE" onChange={handleFilterChange} value={attendanceFilter ?? ""}>
                      <option value="OFFLINE">{t("in_person")}</option>
                      <option value="ONLINE">{t("Online")}</option>
                    </Select>
                    <Select placeholder={t("Date")} size={{ base: "lg", md: "md" }} bg={"#F2F4F7"}
                            name="date" onChange={handleFilterChange} value={dateFilter}>
                      <option value="TODAY">{t("Today")}</option>
                      <option value="TOMORROW">{t("Tomorrow")}</option>
                      <option value="THISWEEK">{t("This week")}</option>
                    </Select>
                  </Box>
                  <Box display={"flex"} gap={"20px"} flexDirection={{ base: "column", md: "row" }}>
                    <Select placeholder={t("TicketType")} size={{ base: "lg", md: "md" }} bg={"#F2F4F7"}
                            name="ticketType" onChange={handleFilterChange} value={ticketType ?? ""}>
                      <option value="FREE">{t("Free")}</option>
                      <option value="PAID">{t("Paid")}</option>
                      <option value="OTHER">{t("Other")}</option>
                    </Select>
                    <Button onClick={handleClearFilter} bg={"#002D71"} color={"#fff"}
                            size={{ base: "lg", md: "md" }} padding="0 30px!important">
                      {t("Clear Filter")}
                    </Button>
                  </Box>
                </Flex>
              </>
          )}

          {/* Search Results */}
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing="60px">
            {searchData.length > 0 ? (
                searchData.filter(event =>
                    event.eventName.toLowerCase().includes(searchField.toLowerCase())
                ).map((event, index) => <CardItem {...event} key={index} />)
            ) : (
                <Text>Not found</Text>
            )}
          </SimpleGrid>

          {/* Load More Button */}
          <Flex justify="center" mt={6}>
            <Button onClick={handleLoadMore} isLoading={isLoading || loadingFilter} disabled={isLoading}>
              {t("Load More")}
            </Button>
          </Flex>
        </Container>
      </Box>
  );
}
